// Constants
export const SHOW_MENU = "SHOW_MENU";
export const ENABLE_MENU = "ENABLE_MENU";
